import { useCallback } from 'react';
import { type UpdateQueryParameterValues } from '../../hooks/use-update-query-parameter-values';

interface UseSetPaginationAndRowsPerPageProperties {
  rowsPerPage: number;
  updateQueryParameterValues: UpdateQueryParameterValues;
}

interface PaginationUpdateProperties {
  paginationValue: number;
  rowsPerPage?: number;
}

const useSetPaginationAndRowsPerPage = ({
  rowsPerPage,
  updateQueryParameterValues,
}: UseSetPaginationAndRowsPerPageProperties): ((arguments_: PaginationUpdateProperties) => void) => {
  return useCallback(
    ({ paginationValue, rowsPerPage: rowsPerPageLocal }: PaginationUpdateProperties): void => {
      if (rowsPerPageLocal && rowsPerPageLocal !== rowsPerPage) {
        updateQueryParameterValues({
          filterKeys: { rowsPerPage: [rowsPerPageLocal.toString()] },
        });
      } else {
        updateQueryParameterValues({
          filterKeys: { page: [String(paginationValue)] },
        });
      }
    },
    [rowsPerPage, updateQueryParameterValues],
  );
};

export default useSetPaginationAndRowsPerPage;
